<template lang="pug">
	div.container-fluid
		.card
			.card-header.bg-info.text-white
				span.fa.fa-info-circle.mr-2
				| Información
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3.mb-2
						.form-group
							label
								b Programa
							select.form-control
					.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3.mb-2
						.form-group
							label
								b Día
							select.form-control
					.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3.mb-2
						.form-group
							label
								b Estilo de escaleta
							select.form-control
					.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3.mb-2
						.form-group
							label
								b Importar desde
							select.form-control

		.card.mt-2
			.card-header.bg-dark.text-white
				span.fa.fa-list.mr-2
				| Contenido de la escaleta - TÉCNICA
				button.close(@click="nuevaLinea()")
					span.fa.fa-plus
			table.table.table-striped.m-0
				thead
					tr
						th.celdaNum #
						th.celdaHora Hora
						th.celdaDuracion Duración
						th Contenido
						th Notas técnicas
						th.celdaBoton
				tbody
					tr(
						v-for="(linea, i) in Escaleta.Lineas"
						:key="i"
					)
						td.celdaNum {{(i + 1)}}
						td.celdaHora
							input.form-control(v-mask="'##:##'", v-model="Escaleta.Lineas[i].Hora")
						td.celdaDuracion
							input.form-control(v-mask="'##:##'", v-model="Escaleta.Lineas[i].Duracion")
						td
							div.mb-1(
								v-for="(item, c) in linea.Contenido"
								:key="i + '-cont-' + c"
							)
								textarea.form-control(v-if="item.tipo === 'comentario'", placeholder="Aquí tu comentario")
							span.fa.fa-edit.m-2(style="cursor:pointer;", title="Agregar comentario", @click="nuevoComentario(Escaleta.Lineas[i].Contenido)")
							span.fa.fa-file-o.m-2(style="cursor:pointer", title="Vincular noticia")
						td
							div.mb-1(
								v-for="(item, c) in linea.NotasTecnicas"
								:key="i + '-cont-' + c"
							)
								textarea.form-control(v-if="item.tipo === 'comentario'", placeholder="Aquí tu comentario")
								Telefono(v-if="item.tipo === 'telefono'", :telefono.sync="Escaleta.Lineas[i].NotasTecnicas[c].telefono", :nombre.sync="Escaleta.Lineas[i].NotasTecnicas[c].nombre")
							span.fa.fa-edit.m-2(style="cursor:pointer;", title="Agregar comentario", @click="nuevoComentario(Escaleta.Lineas[i].NotasTecnicas)")
							span.fa.fa-volume-up.m-2(style="cursor:pointer;", title="Agregar corte de audio")
							span.fa.fa-phone.m-2(style="cursor:pointer;", title="Agregar teléfono", @click="nuevoTelefono(Escaleta.Lineas[i].NotasTecnicas)")
						th.celdaBoton
							button.btn.btn-danger(@click="Escaleta.Lineas.splice(i, 1)")
								span.fa.fa-trash.mr-2
								| Quitar
			.card-footer
				button.btn.btn-primary(@click="nuevaLinea()")
					span.fa.fa-plus.mr-2
					| Nueva línea
</template>


<script>
import Telefono from './telefono'
export default {
	components: {
		Telefono
	},
	data () {
		return {
			Escaleta: {
				ProgramaID: null,
				ProgramaNombre: null,
				Dia: null,
				Estilo: null,
				Lineas: []
			}
		}
	},
	methods: {
		nuevaLinea () {
			console.log('Creamos una nueva línea')
			this.Escaleta.Lineas.push({
				Hora: null,
				Duacion: null,
				Contenido: [],
				NotasTecnicas: []
			})
		},
		nuevoComentario (destino) {
			destino.push({
				tipo: 'comentario',
				contenido: ''
			})
		},
		nuevoTelefono (destino) {
			destino.push({
				tipo: 'telefono',
				telefono: '0034',
				nombre: ''
			})
		},
		importarNoticia (destino) {

		}
	}
}
</script>

<style>
.celdaNum {
	width: 30px;
	max-width: 30px;
}

.celdaHora {
	width: 100px;
	max-width: 100px;
}
.celdaDuracion {
	width: 100px;
	max-width: 100px;
}

.celdaBoton {
	max-width: 100px;
	width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/modulos/escaletas/vue/components/editor/editor.vue